import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import ui from "@/assets/scripts/ui";

export default {

    methods: {

        openChecklistReport(statusChecklist, enterpriseId, checklistId, typeChecklistId, checklistNumber, businessTypeSurvey) {

            if (statusChecklist === StatusChecklistType.type.FINISHED) {

                const linkPrintNotDefault = this.getRenderRule("linkPrintNotDefault")
                let path

                if (this.objValid(linkPrintNotDefault)) {
                    //Utilizado por enquanto para Cohab9
                    path = linkPrintNotDefault + checklistNumber + "?enterpriseId=" + enterpriseId + "&checklistId=" + checklistId + "&typeChecklistId=" + typeChecklistId + "&businessTypeSurvey=" + businessTypeSurvey
                } else {

                    if (this.routeExistsByName('checklist-report')) {
                        path = '/checklist/report?enterpriseId=' + enterpriseId + '&checklistId=' + checklistId + '&typeChecklistId=' + typeChecklistId + "&businessTypeSurvey=" + businessTypeSurvey
                    } else {
                        path = '/custom/checklist/report?enterpriseId=' + enterpriseId + '&checklistId=' + checklistId + '&typeChecklistId=' + typeChecklistId + "&businessTypeSurvey=" + businessTypeSurvey
                    }

                }

                this.goPath(path, null, true)

            } else {
                ui.msg(this, 'Informação', 'Para gerar o relatório desta inspeção, é necessário que ela esteja finalizada.')
            }

        }

    }
}




